(() => {
  if (window.__collectionNativeFiltersMobileBound) return;
  window.__collectionNativeFiltersMobileBound = true;

  const mobileQuery = window.matchMedia("(max-width: 767px)");

  const getOverlay = (drawer) => {
    if (!drawer || !drawer.parentElement) return null;
    return drawer.parentElement.querySelector(".collection-native-filters-overlay");
  };

  const getOpenButtons = (drawer) => {
    if (!drawer || !drawer.id) return [];
    return document.querySelectorAll(
      `[data-native-filter-open][aria-controls="${drawer.id}"]`
    );
  };

  const setOpenState = (drawer, isOpen) => {
    const overlay = getOverlay(drawer);

    drawer.classList.toggle("is-open", isOpen);
    if (overlay) overlay.classList.toggle("is-visible", isOpen);

    getOpenButtons(drawer).forEach((button) => {
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    document.body.classList.toggle("collection-native-filter-lock", isOpen);

    if (isOpen) {
      window.setTimeout(() => {
        const closeButton = drawer.querySelector("[data-native-filter-close]");
        if (closeButton) closeButton.focus();
      }, 80);
    }
  };

  const openDrawer = (drawer) => {
    if (!drawer || !mobileQuery.matches) return;
    setOpenState(drawer, true);
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    setOpenState(drawer, false);
  };

  const closeAllDrawers = () => {
    document
      .querySelectorAll("[data-native-filter-drawer].is-open")
      .forEach((drawer) => closeDrawer(drawer));
  };

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest("[data-native-filter-open]");
    if (openButton) {
      const drawerId = openButton.getAttribute("aria-controls");
      openDrawer(document.getElementById(drawerId));
      event.preventDefault();
      return;
    }

    if (event.target.closest("[data-native-filter-close]")) {
      closeAllDrawers();
      event.preventDefault();
      return;
    }

    const applyButton = event.target.closest(
      "[data-native-filter-drawer] .filter--button[data-type='apply']"
    );
    if (applyButton) closeAllDrawers();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAllDrawers();
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", (event) => {
      if (!event.matches) closeAllDrawers();
    });
  } else {
    mobileQuery.addListener((event) => {
      if (!event.matches) closeAllDrawers();
    });
  }
})();
